import React from 'react';

function TableHead({ name, width, rightAlign, isWrap = false }) {
  const style = { width: `${width}%` };

  return (
    <div
      className={`flex ${rightAlign ? 'justify-end' : 'justify-start'} px-3 ${isWrap ? 'whitespace-nowrap' : ''}`} // If design break, remove margin
      style={style}>
      {name}
    </div>
  );
}

export default TableHead;
